export default __webpack_public_path__ + "static/media/Thai.22d9040a.png";